import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../../services/localiser";

@Component({
  selector: 'app-info-grupos',
  templateUrl: './info-grupos.component.html',
  styleUrls: ['./info-grupos.component.css']
})
export class InfoGruposComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InfoGruposComponent>, public localiser: Localiser) { }

  ngOnInit(): void {
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
